import { Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { showNotification } from '@mantine/notifications';
import { SettingsButton } from '@repo/common/components';
import { Text } from '@repo/foundations';
import { useSuspenseFeatureAccess } from '../../../api';
import { MetaplaneImportController } from '../../../features/MetaplaneImport';
import { UpgradeButton } from '../UpgradeButton';

export function MetaplaneMonitorImportSettings() {
	const { exportAccess } = useSuspenseFeatureAccess();
	const [opened, { open, close }] = useDisclosure(false);

	const openImportModal = () => {
		if (!exportAccess) {
			return;
		}
		open();
	};

	const handleComplete = (successMessage: string) => {
		close();
		showNotification({
			title: 'Success',
			message: successMessage,
			color: 'green',
		});
	};

	const handleCancel = () => {
		close();
	};

	return (
		<>
			<SettingsButton
				title="Import Metaplane monitors"
				description={
					<Text size="xs" color="text/secondary/default">
						Import monitors from Metaplane
					</Text>
				}
				buttonText="Import monitors"
				onClick={openImportModal}
			>
				{!exportAccess && <UpgradeButton feature="Import" />}
			</SettingsButton>

			<Modal
				opened={opened}
				onClose={handleCancel}
				title="Import Metaplane Monitors"
				size="xl"
			>
				<MetaplaneImportController
					onComplete={handleComplete}
					onCancel={handleCancel}
				/>
			</Modal>
		</>
	);
}
